
import { Result, Button } from 'antd';
import { useSearchParams, useParams, useNavigate } from 'react-router-dom';

export default function PaymentResult() {
  const [sp] = useSearchParams();
  const status = sp.get('status') || 'success';
  const { propcode } = useParams<{ propcode: string }>()
  const navigate = useNavigate();
  const onBackMainPage = () =>{
    navigate(`/booking/${propcode}/`)
  }

  if (status === 'success') {
    return <Result status="success" title="Payment Successful" extra={<Button onClick={onBackMainPage} type="primary">OK</Button>} />;
  }
  return <Result status="error" title="Payment Failed" extra={<Button onClick={onBackMainPage} type="primary">OK</Button>} />;
}
